import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CancelledEula from './cancelled-eula';
import AcceptableEula from './acceptable-eula';
import history from '../../history';
export const Eula = ()=>{
    const { isCancelled, eula } = useSelector((state)=>state.eula);
    const dispatch = useDispatch();
    useEffect(()=>{
        if (eula.eulaId === null) {
            history.push('/');
        }
    }, [
        dispatch,
        eula
    ]);
    if (!isCancelled) {
        return /*#__PURE__*/ _jsx(AcceptableEula, {});
    } else {
        return /*#__PURE__*/ _jsx(CancelledEula, {});
    }
};
